export default {"src":"/_next/static/media/ph.f42414cd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};